import classNames from 'classnames';
import styled from 'styled-components';

export const PlayList = styled.div<{ $activeIndex: number }>`
  width: 10000px;
  margin-left: ${({ $activeIndex }) => -200 * $activeIndex}px;
  transition: margin-left 0.5s;
`;

interface PlayListButtonProps {
  type: 'prev' | 'next';
  onClick(): void;

  disabled: boolean;
}

export function PlayListButton({ type, onClick, disabled }: PlayListButtonProps) {
  const direction = type === 'prev' ? 'left' : 'right';
  return (
    <div
      className="d-none d-lg-flex position-absolute"
      style={{
        zIndex: 99,
        minHeight: 150,
        right: type === 'next' ? 0 : undefined,
        background: `linear-gradient(to ${type === 'prev' ? 'right' : 'left'}, #000, rgba(0, 0, 0, 0) 100%)`,
      }}
      role="navigation"
      aria-label={direction}
    >
      <button
        className={classNames('btn btn-flat-light px-0', type)}
        type="button"
        onClick={onClick}
        disabled={disabled}
      >
        <i className="icon">chevron_{direction}</i>
      </button>
    </div>
  );
}
